
export default (key, reducers) => {
  return (state, action) => {
    const isSingleReducer = typeof reducers === 'function';

    if(state === undefined) {
      const newState = {};

      if(!isSingleReducer) {
        const values = Object.keys(reducers);

        values.forEach(value => {
          newState[value] = reducers[value](undefined, action);
        });
      }

      return newState;
    }

    const value = action[key];

    if(value) {
      let reducer = isSingleReducer ? reducers : reducers[value];

      if(reducer) {
        return {
          ...state,
          [value]: reducer(state[value], action)
        };
      }
    }

    return state;
  };
};



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/reducersMakers/byKeyMaker.js
 **/